import module from 'contabilidad/polizasexternas/module'
import template from './template.html'
import { orderBy } from 'lodash'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class ContabilidadPolizasexternasAlgodonerosIngresosListaVinculacionComponent {
  fecha = undefined
  facturas = []
  registros = []
  facturaSeleccionada = false
  totalRelacionado = 0
  totalPendiente = 0
  buscando = false
  opciones = [
    { id: 1, descripcion: 'Souvenir' },
    { id: 2, descripcion: 'Membresias' },
    { id: 3, descripcion: 'Publicidad' },
    { id: 4, descripcion: 'Conekta' },
    { id: 5, descripcion: 'Paypal' },
    { id: 6, descripcion: 'Concesión' },
    { id: 7, descripcion: 'Taquilla' },
    { id: 8, descripcion: 'Cerveza' },
    { id: 9, descripcion: 'Bebidas' },
    { id: 10, descripcion: 'Renta inmueble' },
    { id: 11, descripcion: 'Sueros' },
    { id: 12, descripcion: 'Paquete Cumpleañero' },
    { id: 13, descripcion: 'Otros' },
  ]
  series = [
    { id: 1, descripcion: 'Todo' },
    { id: 2, descripcion: 'A' },
    { id: 3, descripcion: 'B' },
    { id: 4, descripcion: 'C' },
    { id: 5, descripcion: 'EC' },
    { id: 6, descripcion: 'D' },
    { id: 7, descripcion: 'E' },
    { id: 8, descripcion: 'F' },
  ]
  metodosPagos = [
    { id: 1, descripcion: 'Todo' },
    { id: 2, descripcion: 'PUE' },
    { id: 3, descripcion: 'PPD' },
  ]
  saldos = [
    { id: 1, descripcion: 'Todo' },
    { id: 2, descripcion: '=' },
    { id: 3, descripcion: '>' },
    { id: 4, descripcion: '<' },
  ]

  filtroSerie = 'Todo'
  filtroMetodoPago = 'Todo'
  filtroSaldo = 'Todo'
  filtroImporte = 0

  constructor(PolizasExternasAlgodonerosIngresos) {
    this.polizasExternasAlgodonerosIngresos = PolizasExternasAlgodonerosIngresos
  }

  $onInit() {
    this.fecha = new Date(this.movimiento.fecha)
    this.fecha.setDate(this.fecha.getDate() - 30)
    this.fechaFinal = new Date(this.movimiento.fecha)

    this.movimiento.relacionados = []

    this.obtenerDescripcion()

    this.actualizarInformacion()

    this.totalPendiente = this.movimiento.importe - this.movimiento.totalvinculado
  }

  obtenerDescripcion() {
    if (!this.movimiento.descripcion) return

    let busqueda = normalizar(this.movimiento.descripcion)
    let encontrado = this.opciones.find((item) => normalizar(item.descripcion).includes(busqueda))

    this.descripcion = encontrado ? encontrado.descripcion : null

    if (!this.descripcion) {
      this.descripcion = 'Otros'
      this.otros = this.movimiento.descripcion
    }
  }

  actualizarInformacionDelay() {
    setTimeout(() => {
      this.actualizarInformacion();
    }, 1000);
  }

  actualizarInformacion() {
    if (!this.fecha || !this.fechaFinal) return

    this.buscando = true
    this.facturaSeleccionada = false
    this.totalRelacionado = this.movimiento.totalvinculado
    this.movimiento.relacionados = []
    this.registros = []
    this.data = []
    this.polizasExternasAlgodonerosIngresos.vinculacion(this.fecha, this.fechaFinal)
      .then((resolve) => { this.data = resolve.data })
      .then(() => { this.filtrarDatos() })
      .finally(() => { this.buscando = false })
  }

  cancelar() {
    if (this.vinculando) return
    this.onClose()
  }

  finalizar(item) {
    this.onClose(item)
  }

  preSeleccionar(item) {
    this.itemSeleccionado = item
    if (!item.relacionado) {
      this.selecc = true
    } else {
      this.seleccionar(1)
    }
  }

  seleccionar(importe) {
    console.log('seleccionar', importe)
    let item = this.itemSeleccionado
    this.itemSeleccionado = false
    this.selecc = false

    if (!importe) return

    if (item.relacionado) {
      this.movimiento.relacionados = this.movimiento.relacionados.filter((i) => i.id !== item.id)
    } else {
      this.movimiento.relacionados.push({ ...item, totalEnFactura: importe })
    }

    this.totalRelacionado = (this.movimiento.relacionados.reduce((total, item) => +item.totalEnFactura + total, 0) + this.movimiento.totalvinculado)
    console.log('totalRelacionado', this.totalRelacionado)
    item.relacionado = !item.relacionado

    this.totalPendiente = this.movimiento.importe - this.totalRelacionado

    console.log('pendiente', this.totalPendiente)

    this.mapearFacturas()
  }

  vincular() {
    console.log('vincular', this.movimiento)
    if (this.vinculando) return

    this.vinculando = true

    this.polizasExternasAlgodonerosIngresos.post({
      movimientoId: this.movimiento.id,
      fecha: this.movimiento.fecha.toYMD(),
      notas: this.descripcion,
      otros: this.otros,
      facturas: this.movimiento.relacionados
    }).then((response) => {
      this.movimiento.totalvinculado = this.totalRelacionado
      this.movimiento.facturas += (this.movimiento.relacionados.length)
      this.onClose({ $event: this.movimiento })
    })
      .finally(() => { this.vinculando = false })
  }

  mapearFacturas() {
    this.data = orderBy(this.data.map((factura) => {
      this.movimiento.relacionados.forEach((movi) => {
        if (factura.id == movi.facturaId) {
          factura.relacionado = true
        }
      })

      return factura
    }), ['fecha', 'relacionado'])
  }

  filtrarDatos() {
    if (this.filtroSerie === 'Todo' && this.filtroMetodoPago === 'Todo' && this.filtroSaldo === 'Todo') {
      this.movimientosFiltrados = this.data
      return
    }

    this.movimientosFiltrados = this.data

    if (this.filtroSerie !== 'Todo') {
      this.movimientosFiltrados = this.movimientosFiltrados.filter((valor) => normalizar(valor.serie) === normalizar(this.filtroSerie))
    }

    if (this.filtroMetodoPago !== 'Todo') {
      this.movimientosFiltrados = this.movimientosFiltrados.filter((valor) => normalizar(valor.metodoPago) === normalizar(this.filtroMetodoPago))
    }

    if (this.filtroSaldo !== 'Todo') {
      if (this.filtroImporte) {
        this.movimientosFiltrados = this.movimientosFiltrados.filter((valor) => {
          switch (this.filtroSaldo) {
            case '=':
              return parseFloat(valor.saldo).toFixed(2) == this.filtroImporte
            case '>':
              return parseFloat(valor.saldo).toFixed(2) >= this.filtroImporte
            case '<':
              return parseFloat(valor.saldo).toFixed(2) <= this.filtroImporte
          }
        })
      }
    }
  }

}

module.component('contabilidadPolizasexternasAlgodonerosIngresosListaVinculacion', {
  controller: ContabilidadPolizasexternasAlgodonerosIngresosListaVinculacionComponent,
  template,
  bindings: {
    movimiento: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/ingresos/lista/vinculacion/component.js